import React from 'react'
import { shuffleArray } from '@brainstud/react-helpers'

export default Component => {
  return class extends React.Component {
    state = this.props.data ? { ...this.props.data.state } : {
      submitted: false,
      passed: false,
      dragList: [],
      dropList: [],
      attempts: false,
    }

    componentDidMount() {
      // if(this.props.assignment.progress.attempts) {
      //   this.setState({ attempts: true })
      // }

      if (!this.props.data) {
        this.setLists()
      }
    }

    setLists() {
      const draggables = this.props.draggables.reduce((acc, item, idx) => acc.concat({
        ...item,
        id: idx + 1,
        dropped: false,
        active: false,
        correct: false,
        labelActive: item.labelActive || item.label,
      }), [])

      this.setState({
        dragList: draggables,
        dropList: this.props.droppables,
        'list-0': shuffleArray([...draggables]),
      })
    }

    get options() {
      return { ...this.props.options }
    }

    get draggables() {
      return this.state['list-0'] || []
    }

    get isFilled() {
      return this.draggables.length < 1
    }

    getScore = () => {
      const draggableList = this.state.dropList.reduce((acc, item) => {
        const list = this.state[`list-${item.id}`]
        return list ? acc.concat(list) : acc
      }, [])

      const correct = draggableList.reduce((acc, item) => item.correct ? acc + 1 : acc, 0)
      const wrong = draggableList.reduce((acc, item) => item.correct ? acc : acc + 1, 0)
      return {
        correct,
        wrong,
        passed: correct === this.state.dragList.length,
        worth: Math.round(100 / this.state.dragList.length),
      };
    };

    apiData = () => {
      const {correct, wrong, passed, worth} = this.getScore();

      return {
        exercise: {
          passed,
          score: passed ? 100 : correct * worth,
          correct,
          wrong,
        },
        state: this.state,
      }
    }

    handleDragStart = item => {
      this.setState(state => {
        return {
          ['list-0']: state['list-0'].map(itm => itm.id === item.id
            ? { ...itm, active: true }
            : itm
          ),
        }
      })
    }
    handleDragEnd = item => {
      this.setState(state => {
        return {
          ['list-0']: state['list-0'].map(itm => itm.id === item.id
            ? { ...itm, active: false }
            : itm
          ),
        }
      })
    }

    handleDrop = e => {
      const item = e.dragData
      const target = e.dropData

      if (item.dropped === target.id) return

      this.setState(state => {
        const fromListName = `list-${item.dropped || 0}`
        const targetListName = `list-${target.id}`

        const fromList = state[fromListName].reduce((acc, itm) => {
          return itm.id === item.id ? acc : acc.concat(itm)
        }, [])

        const droppedItem = {
          ...item,
          dropped: target.id,
          correct: item.droppable === target.id,
        }
        const targetList = state[targetListName] ? state[targetListName].concat(droppedItem) : [].concat(droppedItem)

        return {
          [fromListName]: fromList,
          [targetListName]: targetList,
        }
      }, () => { if(typeof this.props.onChange === 'function') this.props.onChange(this.apiData())} )
    }
    handleSubmit = e => {
      if (!this.isFilled) return

      const { passed } = this.getScore();

      this.setState({ submitted: true, passed }, () => this.props.onSubmit(this.apiData()))
    }

    handleReset = () => {
      this.state.dropList.forEach(item => {
        delete this.state[`list-${item.id}`]
      })

      delete this.state[`list-0`]
    }
    handleRestart = () => {
      this.state.dropList.forEach(item => {
        delete this.state[`list-${item.id}`]
      })

      this.setState({
        form: true,
        submitted: false,
        passed: false,
        dragList: [],
        dropList: [],
      }, this.setLists)
    }

    render() {
      return <Component {...this.props} dnd={{
        state: this.state,
        options: this.options,
        draggables: this.draggables,
        isFilled: this.isFilled,
        handleDragStart: this.handleDragStart,
        handleDragEnd: this.handleDragEnd,
        handleDrop: this.handleDrop,
        handleSubmit: this.handleSubmit,
        handleReset: this.handleReset,
        handleRestart: this.handleRestart,
      }} />
    }
  }
}
